<template>
	<div>
		<c-dialog ref="dialog" mode="slide" width="500" mask-close @close="dialogFormEditConfirm($refs.form, arguments)" @resolve="submitHandle">
			<c-tips>单个业务的自定义字段最多可创建{{freeEdition ? systemConfig.free_field_count : systemConfig.vip_field_count}}个</c-tips>

			<c-form ref="form" unit-width="100%" vertical>
				<c-input type="hidden" name="id"></c-input>
				<c-form-item v-if="copyState" label="复制到" required>
					<c-select v-model="copyToWorkType" name="work_type_id" :options="copyToOptions" :clear="false" @change="changeCopyTo"></c-select>
				</c-form-item>

				<c-form-item label="字段名称" required>
					<c-input name="field_title"></c-input>
				</c-form-item>

				<c-form ref="config" name="config_json" link-parent>
					<c-form-item label="字段类型" required>
						<c-select v-model="fieldType" name="type" :options="typeOptions" :disabled="editState" :clear="false"></c-select>
					</c-form-item>

					<c-form-item v-if="fieldType == 'option'" label="设置选项" required>
						<template #handle>
							<c-link @click="batchOptionHandle">批量添加选项</c-link>
							<c-link style="margin-left: 10px;" @click="addOptionHandle">添加选项</c-link>
						</template>

						<c-table v-paste="addOptionHandle" ref="optionList" :data="optionList" border style="max-height: 430px;" @dataChange="updateOptionDefaultOptions">
							<c-table-column
								type="drag"
							></c-table-column>

							<c-table-column
								label="选项内容"
								width="240"
							>
								<template #default="{data}">
									<c-input v-model="data.value"></c-input>
								</template>
							</c-table-column>

							<c-table-column
								label="操作"
								width="40"
								align-center
							>
								<template #default="row">
									<c-link style="color: #f55;" @click="row.remove()">删除</c-link>
								</template>
							</c-table-column>
						</c-table>
					</c-form-item>

					<c-form-item v-if="fieldType == 'rel_object'" label="关联对象" required>
						<div class="group flex-column">
							<div>
								<label>业务对象</label>
								<c-select name="target_work_type_id" :options="objectSourceList" :clear="false" placeholder="请选择业务对象" @change="updateObjectSourceField"></c-select>
							</div>
							
							<div>
								<div class="flex-baseline">
									<label>显示字段</label>
								</div>
								<c-select name="show_field_ids" :multiple="{linefeed: true}" :options="objectSourceFieldList" :clear="false" placeholder="请选择显示字段"></c-select>
							</div>
							
							<div>
								<div class="flex-between-center">
									<label>数据填充规则</label>
									<c-link @click="addObjectFillRule">添加规则</c-link>
								</div>
								<div ref="objectRull" class="object-rule">
									<ul>
										<li v-for="(item, i) in objectFillRule" :key="item.key" class="flex-center">
											<c-select v-model="item.source_field_id" :options="objectSourceFieldList" :clear="false" @change="objectSourceHandle(item, $event)"></c-select>
											<i class="tf">&#xeb08;</i>
											<c-select v-model="item.target_field_id" :options="objectTargetFieldList[item.source_field_type]" :disable-options="selectedObjectTargetField" :clear="false"></c-select>
											<a @click="removeObjectFillRule(i)"><i class="tf-trash"></i></a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</c-form-item>

					<c-form-item v-if="fieldType == 'formula'" label="计算公式" required>
						<c-button prepend-icon="tf-edit" @click="$refs.formulaEdit.open()">编辑公式</c-button>
					</c-form-item>

					<c-form-item v-show="fieldType && fieldType != 'formula'" label="字段属性">
						<c-checkbox-group v-model="fieldAttr" name="attr" class="sub">
							<div class="sub-item">
								<c-checkbox value="required" :disabled="fieldAttr.includes('readonly')">必填</c-checkbox>
							</div>
							<div v-if="readonlyAttr" class="sub-item">
								<c-checkbox value="readonly" :disabled="fieldAttr.includes('required')">只读</c-checkbox>
							</div>
							<div v-if="fieldType == 'text'" class="sub-item">
								<c-checkbox value="textarea" :disabled="fieldAttr.includes('suggest')">多行</c-checkbox>
							</div>
							<div v-if="fieldType == 'number'" class="sub-item flex-center-cross">
								<div class="sub-item-option">
									<c-checkbox value="decimal">小数位数</c-checkbox>
								</div>
								<c-input v-show="fieldAttr.includes('decimal')" v-model="numberDecimal" class="sub-unit" type="stepper" name="decimal" range="1,5" align-center :clear="false" placeholder="请输入" @blur="numberDecimal = numberDecimal || 0"></c-input>
							</div>
							<div v-if="multipleAttr" class="sub-item">
								<c-checkbox value="multiple" @change="multipleHandle">多选</c-checkbox>
							</div>
							<div v-if="fieldType == 'text'" class="sub-item">
								<c-checkbox value="scan">扫码输入</c-checkbox>
							</div>
							<div v-if="fieldType == 'text'" class="sub-item flex-center-cross">
								<c-checkbox value="suggest" :disabled="fieldAttr.includes('textarea')">预设值</c-checkbox>
								<template v-if="fieldAttr.includes('suggest')">
									<c-checkbox value="addSuggest">允许用户添加预设值</c-checkbox>
									<c-tooltip width="200" position="top" tip="当用户输入的内容在预设值列表中不存在时，允许用户直接创建该预设值"></c-tooltip>
								</template>
							</div>
							<div v-if="fieldType == 'option'" class="sub-item flex-center-cross">
								<c-checkbox value="add">允许用户添加选项</c-checkbox>
								<c-tooltip width="200" position="top" tip="当用户搜索的选项在备选列表中不存在时，允许用户直接创建该选项"></c-tooltip>
							</div>
						</c-checkbox-group>
					</c-form-item>

					<c-form-item v-if="fieldType == 'text'" v-show="fieldAttr.includes('suggest')" label="预设值">
						<template #handle>
							<c-link @click="batchOptionHandle">批量添加预设值</c-link>
							<c-link style="margin-left: 10px;" @click="addOptionHandle">添加预设值</c-link>
						</template>

						<c-table v-paste="addOptionHandle" ref="optionList" :data="optionList" border style="max-height: 430px;">
							<c-table-column
								type="drag"
							></c-table-column>

							<c-table-column
								label="预设值内容"
								width="240"
							>
								<template #default="{data}">
									<c-input v-model="data.value"></c-input>
								</template>
							</c-table-column>

							<c-table-column
								label="操作"
								width="40"
								align-center
							>
								<template #default="row">
									<c-link style="color: #f55;" @click="row.remove()">删除</c-link>
								</template>
							</c-table-column>
						</c-table>
					</c-form-item>

					<c-form-item v-if="fieldType == 'time'" label="显示精度">
						<c-select name="format" :options="timeFormatOptions" :clear="false"></c-select>
					</c-form-item>

					<c-form-item v-if="fieldType == 'option'" label="显示方式">
						<c-select v-model="optionMode" name="mode" :options="optionModeOptions" :clear="false"></c-select>
					</c-form-item>

					<c-form-item v-if="fieldType == 'file'" label="文件类型">
						<c-radio-group v-model="fileSuffixValid" class="sub">
							<div class="sub-item">
								<div class="sub-item-option">
									<c-radio value="0">不限制类型</c-radio>
								</div>
							</div>
							<div class="sub-item-option">
								<c-radio value="1">限制类型</c-radio>
							</div>
							<ul v-show="fileSuffixValid == 1" class="suffix flex-wrap">
								<li v-for="(item, i) in fileSuffixOptions" :key="i" class="flex-column flex-center" :class="{'z-crt': fileSuffixCurrent.includes(item.value)}" @click="suffixHandle(item)">
									<i v-if="fileSuffixCurrent.includes(item.value)" class="check tf-check"></i>
									<i class="icon" :class="`tf-file-${item.value}`"></i>
									<p>{{item.name}}</p>
								</li>
							</ul>
						</c-radio-group>
					</c-form-item>

					<c-form v-show="fieldType && !['rel_object', 'formula'].includes(fieldType)" ref="default" name="default" link-parent>
						<c-form-item label="默认值">
							<c-radio-group v-model="defaultType" name="type" class="sub">
								<div class="sub-item">
									<div class="sub-item-option">
										<c-radio value="0">无</c-radio>
									</div>
								</div>
								<div v-if="defaultConfig.value" class="sub-item flex-center-cross">
									<div class="sub-item-option">
										<c-radio value="1">自定义</c-radio>
									</div>
									<template v-if="defaultType == 1">
										<c-input v-if="fieldType == 'text'" class="sub-unit" name="value" :clear="false" placeholder="请输入"></c-input>
										<c-input v-if="fieldType == 'number'" class="sub-unit" type="stepper" name="value" align-center :decimal="fieldAttr.includes('decimal') ? numberDecimal : 0" :clear="false" placeholder="请输入"></c-input>
										<c-select v-if="fieldType == 'time'" class="sub-unit" name="value" :options="timeDefaultOptions" :clear="false" placeholder="请选择"></c-select>
										<c-select v-if="fieldType == 'option'" ref="optionDefaultOptions" class="sub-unit" name="value" :options="optionDefaultOptions" :multiple="fieldAttr.includes('multiple')" :clear="false" placeholder="请选择"></c-select>
									</template>
								</div>
								<div v-if="defaultConfig.source" v-show="defaultSourceList.length" class="sub-item flex">
									<div class="sub-item-option">
										<c-radio value="2">关联字段</c-radio>
									</div>
									<div v-if="defaultType == 2" class="flex-grow sub-area flex-column">
										<div>
											<label>所属业务</label>
											<c-select class="sub-unit flex-grow" name="source" :options="defaultSourceList" :clear="false" placeholder="请选择所属业务" @change="updateDefaultField"></c-select>
										</div>
										
										<div>
											<div class="flex-baseline">
												<label>关联字段</label>
												<span>(以下字段的值将自动填充到当前字段)</span>
											</div>
											<c-select class="sub-unit flex-grow" name="field" :options="defaultFieldListForType" :clear="false" placeholder="请选择关联字段"></c-select>
										</div>
									</div>
								</div>
							</c-radio-group>
						</c-form-item>
					</c-form>

					<c-form ref="show" name="show" link-parent>
						<c-form-item label="显示条件">
							<c-radio-group v-model="showType" name="type" class="sub">
								<div class="sub-item">
									<div class="sub-item-option">
										<c-radio value="0">始终显示</c-radio>
									</div>
								</div>
								<div v-show="!disabledFormula" class="sub-item flex">
									<div class="sub-item-option">
										<c-radio value="1">满足条件显示</c-radio>
									</div>
									<div v-if="showType == 1" class="flex-grow sub-area flex-column flex-end">
										<div class="formula">{{showFormula || '未定义公式'}}</div>
										<c-link class="formula-edit" color="main" icon="tf-edit" @click="showFormulaHandle">编辑条件公式</c-link>
									</div>
								</div>
							</c-radio-group>
						</c-form-item>
					</c-form>

					<c-form-item v-if="fieldPlaceholder" label="引导文字">
						<c-input name="placeholder"></c-input>
					</c-form-item>
					
					<c-form-item label="提示说明">
						<c-input name="tip"></c-input>
					</c-form-item>
				</c-form>
			</c-form>
		</c-dialog>

		<c-dialog ref="batchAdd" width="600">
			<c-tips>可以使用英文逗号、中文逗号或者换行符来分隔多个内容</c-tips>
			<div style="margin: 14px;">
				<c-input v-model="batchContent" type="textarea" :height-resize="false" style="height: 200px;"></c-input>
			</div>
		</c-dialog>
	</div>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'

	let key = 0;
	
	export default {
		props: {
			type: Number,
			workTypeDict: Object
		},

		data() {
			return {
				copyState: false,
				editState: false,

				copyToWorkType: '',
				fieldType: '',

				fieldAttr: [],

				numberDecimal: 0,

				timeFormatOptions: [{
					name: '年-月-日',
					value: 'yyyy-MM-dd|date'
				}, {
					name: '年-月-日 时',
					value: 'yyyy-MM-dd hh|datetime|hour'
				}, {
					name: '年-月-日 时:分',
					value: 'yyyy-MM-dd hh:mm|datetime|min'
				}, {
					name: '年-月-日 时:分:秒',
					value: 'yyyy-MM-dd hh:mm:ss|datetime|sec'
				}, {
					name: '时:分:秒',
					value: 'hh:mm:ss|time|sec'
				}],

				optionList: [],
				optionMode: '',
				optionModeOptions: [{
					name: '下拉选择',
					value: 'select'
				}, {
					name: '平铺',
					value: 'option'
				}],

				objectSourceList: [],
				objectSourceFieldList: [],
				objectTargetFieldList: {},
				objectFillFieldList: [],
				objectFillRule: [],

				fileSuffixValid: 0,
				fileSuffixCurrent: [],
				fileSuffixOptions: [{
					name: '图片',
					value: 'image'
				}, {
					name: '视频',
					value: 'mp4'
				}, {
					name: 'word',
					value: 'word'
				}, {
					name: 'excel',
					value: 'excel'
				}, {
					name: 'ppt',
					value: 'ppt'
				}, {
					name: 'pdf',
					value: 'pdf'
				}, {
					name: '压缩包',
					value: 'zip'
				}],

				defaultType: 0,
				timeDefaultOptions: [{
					name: '当前时间',
					value: 'now'
				}],
				optionDefaultOptions: [],
				defaultSourceList: [],
				defaultFieldList: [],

				showType: 0,
				showFormula: '',

				batchContent: ''
			}
		},

		computed: {
			...mapState(['systemConfig']),
			...mapState({
				typeOptions: 'fieldType'
			}),
			...mapGetters(['freeEdition', 'customFieldMenu']),

			activeWorkType() {
				return this.copyState ? this.copyToWorkType : this.type;
			},

			copyToOptions() {
				return this.customFieldMenu.map(item => {
					return {
						name: item.menu_name,
						value: this.workTypeDict[item.menu_unique_key.replace('m_custom_', '')]
					}
				});
			},

			readonlyAttr() {
				return ['text', 'number', 'time'].includes(this.fieldType);
			},

			multipleAttr() {
				return ['option', 'file', 'image'].includes(this.fieldType);
			},

			defaultConfig() {
				return {
					value: !['file', 'image', 'object'].includes(this.fieldType),
					source: true
				}
			},

			defaultFieldListForType() {
				return this.defaultFieldList.filter(item => {
					if (this.fieldType == 'text') {
						return ['text', 'number', 'option'].includes(item.config.type);
					} else if (this.fieldType == 'file') {
						return ['file', 'image'].includes(item.config.type);
					} else {
						return item.config.type == this.fieldType;
					}
				});
			},

			fieldPlaceholder() {
				return ['text', 'number', 'time', 'option', 'rel_object'].includes(this.fieldType) || (this.fieldType == 'option' && this.optionMode == 'select');
			},

			disabledFormula() {
				return !this.activeWorkType || ![14].includes(this.activeWorkType);
				return !this.activeWorkType || [41, 33, 40, 48, 21].includes(this.activeWorkType);
			},

			selectedObjectTargetField() {
				return this.objectFillRule.map(item => item.target_field_id).filter(item => item);
			}
		},

		watch: {
			activeWorkType: {
				handler() {
					this.fieldType == 'rel_object' && this.updateObjectTargetField();
				},
				immediate: true
			},

			fieldType(val) {
				this.optionList = [];
				this.objectFillRule = [];
				if (val == 'rel_object') {
					this.updateObjectSource();
					this.updateObjectTargetField();
					this.addObjectFillRule();
				}
				this.$nextTick(() => {
					this.$refs.config.set({
						attr: [],
						decimal: '',
						format: val == 'time' ? 'yyyy-MM-dd|date' : '',
						mode: val == 'option' ? 'select' : '',
						suffix: [],
						default: {
							type: '0'
						}
					})
				})
			}
		},

		methods: {
			async open(data, copy) {
				this.copyState = !!copy;
				this.editState = !!data;
				if (!this.editState && !(await this.checkDataCount('SYSTEM_FIELD', this.type)).data) return;
				this.optionList = [];
				this.defaultSourceList = [];
				this.defaultFieldList = [];
				this.showFormula = '';
				this.updateDefaultSource();
				this.$refs.form.clear();

				if (data) {
					data = JSON.parse(JSON.stringify(data));
					if (copy) {
						data.id = '';
					}
					if (data.config_json.default && data.config_json.default.type == 2) {
						this.updateDefaultField({
							value: data.config_json.default.source
						});
					}
					if (!data.config_json.show) {
						data.config_json.show = {
							type: 0
						}
					}
					this.$refs.form.set(data);
					this.$nextTick(() => {
						if (data.config_json.type == 'text') {
							this.optionList = (data.config_json.suggest || []).map(item => {
								return {
									value: item
								}
							});
						} else if (data.config_json.type == 'option') {
							this.optionList = data.config_json.options || [];
						} else if (data.config_json.type == 'file') {
							this.fileSuffixCurrent = (data.config_json.suffix || []).map(item => item);
							this.fileSuffixValid = this.fileSuffixCurrent.length ? 1 : 0;
						} else if (data.config_json.type == 'rel_object') {
							this.updateObjectSourceField({
								value: data.config_json.target_work_type_id
							});
							if (data.config_json.fill_rules.length) {
								this.objectFillRule = data.config_json.fill_rules.map(item => {
									return {
										key: key++,
										source_field_id: item.source_field_id,
										source_field_type: item.source_field_type,
										target_field_id: item.target_field_id
									}
								});
							}
						}
						this.$refs.form.set(data);
						this.$nextTick(() => {
							this.$refs.form.set(data);
							this.$nextTick(() => {
								this.$refs.form.set(data);
							});
						});
						this.showFormula = data.config_json.show.formula || '';
					});
				} else {
					this.$refs.config.set({
						default: {
							type: '0'
						},
						show: {
							type: '0'
						}
					});
				}
				this.$refs.dialog.open({
					title: copy ? '复制字段' : data ? '编辑字段' : '添加新字段'
				});
			},

			changeCopyTo({value}) {
				this.updateDefaultSource(value);
				if (this.defaultType == 2) {
					this.$refs.config.set({
						default: {
							source: '',
							field: ''
						}
					});
				}
				this.showFormula = '';
				if (this.disabledFormula) {
					this.$refs.config.set({
						show: {
							type: '0'
						}
					});
				}
			},
			
			multipleHandle() {
				this.$nextTick(() => {
					this.$refs.optionDefaultOptions && this.$refs.optionDefaultOptions.set('');
				});
			},

			suffixHandle(item) {
				this.fileSuffixCurrent.includes(item.value) ? this.fileSuffixCurrent.splice(this.fileSuffixCurrent.indexOf(item.value), 1) : this.fileSuffixCurrent.push(item.value);
			},
			
			addOptionHandle() {
				this.$refs.optionList.push({value: ''});
				this.$nextTick(() => {
					this.$refs.optionList.scrollTo(0, 999999);
				});
			},

			batchOptionHandle() {
				this.batchContent = '';
				this.$refs.batchAdd.open({
					title: '批量添加' + (this.fieldType == 'text' ? '预设值' : '选项'),
					resolve: () => {
						this.$refs.optionList.push(
							this.batchContent.replaceAll(/[,，\s]/g, '#split#').split('#split#').map(item => {
								return {
									value: item.trim()
								}
							}).filter(item => item.value)
						);
					}
				});
			},

			updateOptionDefaultOptions() {
				this.optionDefaultOptions = this.$refs.optionList.getData().map(item => {
					return {
						name: item.value.trim(),
						value: item.value.trim()
					}
				}).filter(item => item.value);
			},

			updateObjectSource() {
				this.request({
					url: '/sys_field/relation/work_types',
					success: data => {
						this.objectSourceList = data.map(item => {
							return {
								name: item.work_type_name,
								value: item.work_type_id
							}
						});
					}
				});
			},

			updateObjectSourceField(data) {
				this.objectSourceFieldList = [];
				this.objectFillRule = [];
				this.addObjectFillRule();
				this.request({
					url: '/sys_field/relation/source_fields',
					data: {
						target_work_type_id: data.value
					},
					success: data => {
						this.objectSourceFieldList = data.map(item => {
							return {
								name: item.field_title,
								value: item.field_id,
								type: item.sub_type
							}
						});
					}
				});
			},

			updateObjectTargetField() {
				if (!this.activeWorkType) return;
				this.objectTargetFieldList = {};
				this.request({
					url: '/sys_field/relation/target_fields',
					data: {
						work_type_id: this.activeWorkType
					},
					success: data => {
						data.forEach(item => {
							if (!this.objectTargetFieldList[item.sub_type]) {
								this.$set(this.objectTargetFieldList, item.sub_type, []);
							}
							this.objectTargetFieldList[item.sub_type].push({
								name: item.field_title,
								value: item.field_id
							});
						});
					}
				});
			},

			addObjectFillRule() {
				this.objectFillRule.push({
					key: key++,
					source_field_id: '',
					source_field_type: '',
					target_field_id: ''
				});
				this.$nextTick(() => {
					this.$refs.objectRull.scrollTo(0, 999999);
				});
			},

			removeObjectFillRule(index) {
				this.objectFillRule.splice(index, 1);
				if (!this.objectFillRule.length) {
					this.addObjectFillRule();
				}
			},

			objectSourceHandle(rule, data) {
				rule.source_field_type = data.type;
				rule.target_field_id = '';
			},

			updateDefaultSource(type) {
				this.request({
					url: '/sys_field/ref/datasource/list',
					data: {
						work_type_id: type || this.type
					},
					success: data => {
						if (this.defaultType == 2 && !data.length) {
							this.defaultType = 0;
						}
						this.defaultSourceList = data.map(item => {
							return {
								name: item.name,
								value: item.ref_work_type_id
							}
						});
					}
				});
			},

			updateDefaultField(data) {
				this.defaultFieldList = [];
				this.request({
					url: '/sys_field/list',
					data: {
						work_type_id: data.value
					},
					success: data => {
						this.defaultFieldList = data.map(item => {
							return {
								name: item.field_title,
								value: item.id,
								config: item.config_json
							}
						});
					}
				});
			},

			showFormulaHandle() {
				this.globalDialog('formulaEditor', {
					props: {
						workType: this.activeWorkType
					},
					data: {
						content: this.showFormula
					}
				}, content => {
					this.showFormula = content;
					this.$refs.form.setEditState(true);
				});
			},

			submitHandle(stop, next) {
				stop();
				this.$refs.form.submit({
					url: !this.copyState && this.editState ? '/sys_field/edit' : '/sys_field/add',
					rule: {
						work_type_id: [{
							type: 'empty',
							message: '请选择要复制到哪里',
							skip: (val, data) => {
								return !this.copyState;
							}
						}],
						field_title: '请填写字段名称',
						'config_json.type': '请选择字段类型'
					},
					dataFormatter: data => {
						if (data.config_json.type == 'text' && this.fieldAttr.includes('suggest')) {
							data.config_json.suggest = this.$refs.optionList.getData().map(item => item.value).filter(item => item.trim());
						} else if (data.config_json.type == 'option') {
							data.config_json.options = this.$refs.optionList.getData().map(item => {
								return {
									name: item.value,
									value: item.value
								}
							}).filter(item => item.value.trim());
						} else if (data.config_json.type == 'file') {
							data.config_json.suffix = this.fileSuffixValid == 1 ? this.fileSuffixCurrent : [];
						} else if (data.config_json.type == 'rel_object') {
							data.config_json.fill_rules = this.objectFillRule.filter(item => item.source_field_id && item.target_field_id).map(item => {
								return {
									source_field_id: item.source_field_id,
									source_field_type: item.source_field_type,
									target_field_id: item.target_field_id
								}
							});
						}

						if (
							!data.config_json.default
							|| (data.config_json.default.type == 1 && !data.config_json.default.value.length)
							|| (data.config_json.default.type == 2 && (!data.config_json.default.source || !data.config_json.default.field))
						) {
							data.config_json.default = {
								type: 0
							};
						}

						if (data.config_json.show.type == 1 && !this.showFormula) {
							data.config_json.show.type = 0;
						} else {
							data.config_json.show.formula = this.showFormula;
						}

						data.config_json = JSON.stringify(data.config_json);

						if (!this.copyState) {
							data.work_type_id = this.type;
						}

						return data;
					},
					success: () => {
						next();
						this.$message({
							message: '提交成功'
						});
						this.$emit('resolve');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.group {
		gap: 5px;
		padding: 5px 20px 15px;
		background: #F9F9F9;

		label {
			line-height: 34px;
			font-size: 14px;
			color: #666;
		}

		span {
			margin-left: 6px;
			font-size: 12px;
			color: #666;
		}
	}

	.sub {
		display: flex;
		flex-direction: column;

		&-item {
			gap: 10px;
			min-height: 28px;

			&:nth-child(n+2) {
				margin-top: 4px;
			}

			&-option {
				width: 105px;
				height: 26px;
			}
		}

		&-area {
			gap: 5px;
			padding: 5px 20px 15px;
			background: #F9F9F9;

			label {
				line-height: 34px;
				font-size: 14px;
				color: #666;
			}

			span {
				margin-left: 6px;
				font-size: 12px;
				color: #666;
			}

			.sub-unit {
				width: 100%;
				height: 36px;
			}
		}

		&-unit {
			width: 150px;
			height: 28px;

			>>> .c-select-tag-item {
				line-height: 18px;
			}
		}
	}

	.suffix {
		gap: 8px;
		margin-top: 5px;

		li {
			gap: 6px;
			position: relative;
			width: 54px;
			height: 54px;
			border: 1px solid #F9F9F9;
			border-radius: 4px;
			overflow: hidden;
			font-size: 13px;
			background: #F9F9F9;
			cursor: pointer;

			&:hover {
				background: #ECFFFB;
			}

			&.z-crt {
				border-color: #00B38A;
				background: #ECFFFB;
			}

			.check {
				position: absolute;
				right: 0;
				top: 0;
				width: 16px;
				line-height: 16px;
				font-size: 10px;
				text-align: center;
				color: #fff;
				background: #00B38A;
			}

			.icon {
				font-size: 18px;
			}
		}
	}

	.object-rule {
		max-height: 240px;
		border: 1px solid #ddd;
		overflow: auto;
		background: #fff;

		ul {
			padding: 5px 0;

			li {
				gap: 10px;
				padding: 5px 10px;

				>>> .c-select {
					height: 32px;
				}

				> i {
					color: #999;
				}

				> a {
					font-size: 16px;
					color: #f55;
				}
			}
		}
	}

	.formula {
		box-sizing: border-box;
		width: 100%;
		max-height: 160px;
		border: 1px solid #eee;
		padding: 6px 8px;
		margin-top: 6px;
		overflow: auto;
		line-height: 20px;
		font-size: 13px;
		white-space: pre-wrap;
		word-break: break-all;
		background: #fff;

		&-edit {
			margin-top: 6px;
		}
	}
</style>